import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { StockMoveDocumentHeaderStatusesService } from '../../stock-move-documents/stock-move-document-header-status/stock-move-document-header-statuses.service';
import { StockMoveIncomingHeaderHeaderStatus } from './stock-move-incoming-header-header-status.model';

@Injectable({
  providedIn: 'root'
})
export class StockMoveIncomingHeaderHeaderStatusesService extends StockMoveDocumentHeaderStatusesService<StockMoveIncomingHeaderHeaderStatus> {
  public override url: string = 'StockMoveIncomingHeaderHeaderStatus';
  public override defaultOptions: LoadOptions = {
    expand: ["StatusId"]
  };

}
